import React from "react";

import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

import { ButtonBase } from "@mui/material";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import LineSeparator from "commons/ui/LineSeparator";

import AddRemoveInput from "components/ui/AddRemoveInput";
import AttachmentPicker from "components/ui/AttachmentPicker";

import { OrderableImagesHook } from "hooks/useOrderableImages";

import { DesktopOrMobile } from "types/enums";

type PropsType = {
    orderableImagesHook: OrderableImagesHook;
};

function OrderableImages({ orderableImagesHook }: PropsType) {
    const { deleteRow, setImage, addImage, dragAndDropHook, formHook, visibleItemsLenght } =
        orderableImagesHook;

    const { form, checkErrorVisibility } = formHook;

    const [draggable, setDraggable] = React.useState<boolean>(false);

    return (
        <>
            {form.images.map((image, index) => {
                if (image.toDelete) {
                    return null;
                }

                const divProps: React.DetailedHTMLProps<
                    React.HTMLAttributes<HTMLDivElement>,
                    HTMLDivElement
                > = { className: "" };

                if (dragAndDropHook !== undefined) {
                    divProps.className += " " + dragAndDropHook.classes[index]?.join(" ");

                    divProps.onDragStart = () => dragAndDropHook.onDragStart(index);
                    divProps.onDragEnd = () => dragAndDropHook.onDragEnd(index);
                    divProps.onDragOver = (event) => dragAndDropHook.onDragOver(event);
                    divProps.onDragEnter = () => dragAndDropHook.onDragEnter(index);
                    divProps.onDragLeave = () => dragAndDropHook.onDragLeave(index);
                    divProps.onDrop = () => {
                        dragAndDropHook.onDrop(index);
                        setDraggable(false);
                    };
                }

                return (
                    <div key={index} {...divProps} draggable={draggable}>
                        {index === 0 && <LineSeparator style={{ marginBottom: "1rem" }} />}

                        <GridColumn style={{ marginTop: index !== 0 ? "1rem" : "" }}>
                            <GridRow alignItems={"center"}>
                                <div className={"col-xl-24-2 col-lg-24-1 col-xs-24-1 center-icon"}>
                                    <ButtonBase
                                        style={{ paddingBlock: "1rem" }}
                                        className={"col-xs-12-12 drag-indicator-icon"}
                                        onMouseDown={() => setDraggable(true)}
                                    >
                                        <DragIndicatorIcon />
                                    </ButtonBase>
                                </div>

                                <GridItem className={"col-xl-24-10 col-lg-24-11 col-xs-24-11"}>
                                    <AttachmentPicker
                                        buttonLabel={"Foto Desktop"}
                                        setFile={(file) =>
                                            setImage(file, DesktopOrMobile.desktop, index)
                                        }
                                        file={image.media.desktop}
                                        accept={".png,.jpg,.jpeg"}
                                        errors={checkErrorVisibility(
                                            `images.${index}.media.desktop`
                                        )}
                                    />
                                </GridItem>

                                <GridItem className={"col-xl-24-10 col-lg-24-11 col-xs-24-11"}>
                                    <AttachmentPicker
                                        buttonLabel={"Foto Mobile"}
                                        setFile={(file) =>
                                            setImage(file, DesktopOrMobile.mobile, index)
                                        }
                                        file={image.media.mobile}
                                        accept={".png,.jpg,.jpeg"}
                                        errors={checkErrorVisibility(
                                            `images.${index}.media.mobile`
                                        )}
                                    />
                                </GridItem>

                                <div className={"col-xl-24-2 col-lg-24-1 col-xs-24-1 center-icon"}>
                                    {visibleItemsLenght > 1 && (
                                        <AddRemoveInput
                                            onButtonClick={() => {
                                                deleteRow(index);
                                            }}
                                            minusIcon
                                        />
                                    )}
                                </div>
                            </GridRow>
                        </GridColumn>

                        <LineSeparator style={{ marginTop: "1rem" }} />
                    </div>
                );
            })}

            <GridRow>
                <div className={"col-xl-24-22 col-lg-24-23 col-xs-24-23"}></div>

                <div
                    className={"col-xl-24-2 col-lg-24-1 col-xs-24-1 center-icon"}
                    style={{ marginBlock: "1rem" }}
                >
                    <AddRemoveInput onButtonClick={addImage} addIcon />
                </div>
            </GridRow>
        </>
    );
}

export default OrderableImages;
